module.exports = __webpack_public_path__ + "img/以信息化、标准化为基础-煤炭定制化生产模式研究与应用—国家能源集团公司煤炭产业运营管理中心—1-1.2b41626b.jpg";